import { resetSettingsToDefaultAction as resetSettingsToDefaultOperation } from 'editor/src/store/editor/slice';

export default resetSettingsToDefaultOperation;
